<template>
  <v-card class="text-xs-center">
    <h1 class="text-pagename">Commission Area</h1>
    <commission />
  </v-card>
</template>

<script>
import commission from "@/components/back-office/ManagerUserManage/Commission.vue";
import { mapState } from "vuex";
export default {
  components: {
    commission,
  },
  computed: {
    ...mapState({
      recentPath: (state) => state.backOffice.recentRoutePath,
    }),
  },
  destroyed() {
    this.$store.commit("fetchUserBack/resetState");
  },
  mounted() {
    const path = [
      {
        text: "Select province",
        disabled: false,
        href: "/weserve_admin_login/select/",
      },
      {
        text: "Manager management",
        disabled: true,
        href: "/weserve_admin_login/control/-/manager-manage",
      },
    ];
    this.$store.commit("backOffice/saveRecentRoute", path);
  },
};
</script>

<style></style>
